import {
  useCreateManualPayoffRequestMutation,
  useUserDealLazyQuery,
} from '../gql/generated/graphql';
import { getLeadByExternalId } from '../services/marketplace/generated/kubb/hooks/useGetLeadByExternalId';
import { logger } from '../services/sentry';

type Args = {
  dealId: string;
  externalId: string;
};

const useManualPayoffRequestFallback = ({ dealId, externalId }: Args) => {
  const [createManualPayoffRequest] = useCreateManualPayoffRequestMutation();
  const [fetchUserDeal] = useUserDealLazyQuery({ fetchPolicy: 'network-only' });

  const requestIfMissing = async (): Promise<void> => {
    try {
      const [dealResult, lead] = await Promise.all([
        fetchUserDeal({ variables: { id: dealId } }),
        getLeadByExternalId({ externalId }),
      ]);

      const dealPayoff = dealResult.data?.userDeal?.car?.payoff?.vehicle_payoff ?? null;
      if (dealPayoff != null && dealPayoff > 0) return;
      if (lead?.payoff != null && lead.payoff > 0) return;

      await createManualPayoffRequest({ variables: { dealId } });
    } catch (err) {
      logger.error('useManualPayoffRequestFallback', 'manual payoff request failed', '', err);
    }
  };

  return requestIfMissing;
};

export default useManualPayoffRequestFallback;
